module.exports = __webpack_public_path__ + "static/Les-Harmoniques-0c01cc3eb712e9dc43d6e7998e595b17.pdf";